export const getCurrencyRouteByTag = (tag) => {
  return `/currency/${tag.name}`
}
